import { tickerItems } from "@/mocks/gossipData";
import TopNav from "./components/TopNav";
import FeaturedGrid from "./components/FeaturedGrid";
import ExpressList from "./components/ExpressList";
import TodayTimeline from "./components/TodayTimeline";
import HotThreads from "./components/HotThreads";
import Circles from "./components/Circles";
import CoverGallery from "./components/CoverGallery";
import Footer from "./components/Footer";

function LiveTicker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-7xl items-center px-4 md:px-6">
        <div className="flex shrink-0 items-center gap-2 border-r border-white/15 py-2.5 pr-4">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
          </span>
          <span className="whitespace-nowrap text-xs font-bold tracking-wide">今日滚动速递</span>
          <span className="hidden whitespace-nowrap rounded-full bg-white/10 px-2 py-0.5 text-[11px] sm:inline">
            已更新 28 条
          </span>
        </div>
        <div className="thin-scroll relative ml-4 flex-1 overflow-hidden">
          <div className="marquee-track items-center">
            {items.map((t, i) => (
              <a
                key={i}
                href="#express"
                className="mx-6 inline-flex items-center gap-2 whitespace-nowrap text-xs text-background-50/85 hover:text-accent-400"
              >
                <i className="ri-flashlight-fill text-[11px] text-accent-400" />
                {t}
                <span className="text-white/25">·</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <LiveTicker />
      <main>
        <FeaturedGrid />
        <ExpressList />
        <TodayTimeline />
        <HotThreads />
        <Circles />
        <CoverGallery />
      </main>
      <Footer />

      {/* floating report button */}
      <a
        href="#report"
        aria-label="我要爆料"
        className="fixed bottom-6 right-5 z-40 flex items-center gap-2 rounded-full bg-primary-500 py-3 pl-3.5 pr-4 text-sm font-semibold text-background-50 transition-transform hover:-translate-y-0.5"
      >
        <i className="ri-add-fill text-lg" />
        <span className="hidden sm:inline">爆料</span>
      </a>
    </div>
  );
}